module.exports = __webpack_public_path__ + "img/393fc13.jpg";